export var PersonDocumentType;
(function (PersonDocumentType) {
    PersonDocumentType[PersonDocumentType["CPF"] = 1] = "CPF";
    PersonDocumentType[PersonDocumentType["CNH"] = 2] = "CNH";
    PersonDocumentType[PersonDocumentType["RG"] = 3] = "RG";
})(PersonDocumentType || (PersonDocumentType = {}));
